import axios from 'axios'

/**
 * Centralized API client. Same-origin in both dev (Vite proxy, see
 * vite.config.ts) and production (Flask serves the built bundle), so a plain
 * relative baseURL plus `withCredentials` is all auth needs — the existing
 * Flask-Login session cookie just works, no token handling required.
 */
export const apiClient = axios.create({
  baseURL: '/',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

export class ApiError extends Error {
  status: number
  payload: unknown

  constructor(message: string, status: number, payload: unknown) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.payload = payload
  }
}

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response
      const message =
        (data && typeof data === 'object' && 'error' in data && String((data as Record<string, unknown>).error)) ||
        (data && typeof data === 'object' && 'message' in data && String((data as Record<string, unknown>).message)) ||
        error.message
      return Promise.reject(new ApiError(message, status, data))
    }
    return Promise.reject(error)
  },
)
